import React from "react";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";
import { Link, Typography } from "@mui/material";
import { AUTH_APPS_LIST } from "../constants";

interface AuthAppProps {
  title: string;
  icon: React.ReactNode;
  linkAndroid?: string;
  linkApple?: string;
}

const AuthApp = ({ title, icon, linkAndroid, linkApple }: AuthAppProps) => {
  const { t } = useTranslation();

  const linkProps = {
    target: "_blank",
    rel: "noreferrer",
    sx: {
      textDecoration: "underline",
    },
  };

  return (
    <Box display="flex" flexDirection="row" gap={2.5}>
      {icon}
      <Box display="flex" flexDirection="column" gap={2.5}>
        <Typography variant="body4">{title}</Typography>
        {linkAndroid && (
          <Link href={linkAndroid} {...linkProps}>
            {t("settings.twoFA.methods.linkForAndroid")}
          </Link>
        )}
        {linkApple && (
          <Link href={linkApple} {...linkProps}>
            {t("settings.twoFA.methods.linkForApple")}
          </Link>
        )}
      </Box>
    </Box>
  );
};

export const AuthApps = () => {
  const { t } = useTranslation();

  return (
    <Box
      display="grid"
      gridTemplateColumns="repeat(auto-fit, minmax(250px, 1fr))"
      gap={2.5}
    >
      {AUTH_APPS_LIST.map((app) => (
        <AuthApp
          key={app.title}
          icon={
            <img
              src={app.icon}
              title={app.title}
              alt={app.title}
              width="43px"
              height="43px"
            />
          }
          title={app.title}
          linkAndroid={app.linkAndroid}
          linkApple={app.linkApple}
        />
      ))}
    </Box>
  );
};
